import { ref, computed } from 'vue'

// [
//     {
//         "id": 1,
//         "name": "PutneyBridge",
//         "description": "Area of interest in study of Thames Tideway subsidence. Testing alerts system.",
//         "geometry": "[51.51, -0.175, 51.440, -0.27]",
//         "created": "2024-07-02T13:57:37.075028Z",
//         "updated": "2024-07-02T16:52:41.575270Z",
//         "centre_lat": 51.474999999999994,
//         "centre_lon": -0.2225,
//         "distance_of_interest": 0.03500000000000014,
//         "icon": "default"
//     },
// ]
export interface Project {
  id?: number
  name: string

  [key: string]: string | number | object | string[] | null | undefined
}

export function useProjects() {
  const projects = ref<Project[]>([]) // items is now Ref<Item[]>
  let inFlightFetch: Promise<void> | null = null
  const getItems = async (): Promise<Project[]> => {
    const response = await fetch('/api/projects/?format=json')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch projects')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchProjects = async () => {
    if (inFlightFetch) {
      return inFlightFetch
    }

    inFlightFetch = (async () => {
      projects.value = await getItems()
      // sort the sites by name
      projects.value.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }))
    })().finally(() => {
      inFlightFetch = null
    })

    return inFlightFetch
  }

  const projectKeys = computed(() => {
    return projects.value.length > 0 ? Object.keys(projects.value[0]) : []
  })

  return { projects, fetchProjects, projectKeys }
}
